import "./login.scss";

import React, { useContext, useEffect, useRef, useState } from "react";

import GlobalContext from "../../../contexts/globalContext";
import ModalPay from "../../organisms/modal-pay/modal-pay";
import { firstUpperOnly } from "../../../shared/utils/stringUtilities";
import { navigate } from "gatsby";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

interface LoginInterface {
  title: string;
  isMenuActive?: boolean;
}

const Login = (props: LoginInterface) => {
  const { isBrowser, document } = useBrowserMode();
  const [open, onClose] = useState(false);

  const refMobileContainer: any = useRef(null);
  const toggleModal = () => {
    onClose(!open);
  };
  const [isShow, setIsShow] = useState(false);
  const contextValue = useContext(GlobalContext);
  const options = [
    {
      title: "Mi Comfama",
      icon: "icon-user-circle1",
      gtm: "gtmMenuTransPerfilUsuarioIrAMiPerfil",
      onAction: () => {
        doShow(false);
        contextValue.gigyaContext.updateProfile();
      },
    },
    {
      title: "Mi Nutrición Saludable",
      icon: "a-icon-profile",
      gtm: "gtmMenuTransPerfilUsuarioMiReddeAmor",
      onAction: () => {
        doShow(false);
        navigate("/mis-citas");
      },
    },
    {
      title: "Cerrar sesión",
      icon: "icon-sign-out",
      gtm: "gtmMenuTransPerfilUsuarioCerrarSesion",
      onAction: () => {
        contextValue.gigyaContext.logout();
        doShow(false);
        window.location.reload();
      },
    },
  ];
  const doShow = (show: boolean) => {
    if (isBrowser && show) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.add("freeze-page");
    } else if (isBrowser) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.remove("freeze-page");
    }
    setIsShow(show);
  };

  useEffect(() => {
    // Función que maneja el clic fuera del contenedor
    const handleClickOutside = (event) => {
      if (
        refMobileContainer.current &&
        !refMobileContainer.current.contains(event.target)
      ) {
        // Clic fuera del contenedor, cambia el estado
        setIsShow(false);
      }
    };

    // Agrega un event listener al documento para el clic
    document.addEventListener("click", handleClickOutside);

    // Limpia el event listener al desmontar el componente
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [refMobileContainer]);

  return (
    <GlobalContext.Consumer>
      {(data) => {
        return (
          <div className="a-login">
            <>
              {data.gigyaContext.gigyaAccount ? (
                <div
                  onClick={() => {
                    setTimeout(() => {
                      doShow(!isShow);
                    }, 0);
                  }}
                  className={`a-login__container ${
                    props.isMenuActive ? "a-login__container-open" : ""
                  }`}
                >
                  {/* <span className="a-login__container__title hide-mobile">
                    {`¡Hola ${firstUpperOnly(
                      data.gigyaContext.gigyaAccount.profile.firstName
                    )} ${firstUpperOnly(
                      data.gigyaContext.gigyaAccount.profile.lastName
                    )}!`}
                  </span>

                  <i
                    className={`a-login__container__icon ${
                      isShow ? "icon-caret-up" : "icon-caret-down"
                    } hide-mobile gtmMenuTransPerfilUsuario`}
                    onClick={() => doShow(!isShow)}
                  /> */}

                  <div
                    className={`a-login__container__circle ${
                      !props.isMenuActive ? "hide-mobile" : ""
                    }
                    ${isShow ? "a-login__container__circle-open" : ""} 
                    ${
                      data.gigyaContext.gigyaAccount.profile?.gender === "f"
                        ? "circle-female"
                        : data.gigyaContext.gigyaAccount.profile?.gender === "m"
                        ? "circle-male"
                        : ""
                    }  gtmMenuTransPerfilUsuario`}
                    onClick={() => {
                      doShow(!isShow);
                    }}
                  >
                    {data.gigyaContext.gigyaAccount.profile?.thumbnailURL ? (
                      <div className="a-login__container__circle__cover gtmMenuTransPerfilUsuario ">
                        <img
                          className="a-login__container__circle__cover__img gtmMenuTransPerfilUsuario"
                          alt={data.gigyaContext.gigyaAccount.profile.firstName}
                          src={
                            data.gigyaContext.gigyaAccount.profile.thumbnailURL
                          }
                        />
                      </div>
                    ) : (
                      `${data.gigyaContext.gigyaAccount.profile?.firstName.charAt(
                        0
                      )}${data.gigyaContext.gigyaAccount.profile?.lastName.charAt(
                        0
                      )}`
                    )}
                  </div>

                  {isShow && (
                    <div
                      className="a-login__container__float-box"
                      ref={refMobileContainer}
                    >
                      <ul className="a-login__container__float-box__options">
                        <div className="a-login__container__float-box__options--container-login-image">
                          <div
                            className={`a-login__container__circle ${
                              !props.isMenuActive ? "hide-mobile" : ""
                            }
                  
                            ${
                              data.gigyaContext.gigyaAccount.profile?.gender ===
                              "f"
                                ? "circle-female"
                                : data.gigyaContext.gigyaAccount.profile
                                    ?.gender === "m"
                                ? "circle-male"
                                : ""
                            }  gtmMenuTransPerfilUsuario`}
                          >
                            {data.gigyaContext.gigyaAccount.profile
                              ?.thumbnailURL ? (
                              <div className="a-login__container__circle__cover gtmMenuTransPerfilUsuario ">
                                <img
                                  className="a-login__container__circle__cover__img gtmMenuTransPerfilUsuario"
                                  alt={
                                    data.gigyaContext.gigyaAccount.profile
                                      .firstName
                                  }
                                  src={
                                    data.gigyaContext.gigyaAccount.profile
                                      .thumbnailURL
                                  }
                                />
                              </div>
                            ) : (
                              `${data.gigyaContext.gigyaAccount.profile?.firstName.charAt(
                                0
                              )}${data.gigyaContext.gigyaAccount.profile?.lastName.charAt(
                                0
                              )}`
                            )}
                          </div>
                          <div>
                            <span className="a-login__container__title hide-mobile">
                              {`${firstUpperOnly(
                                data.gigyaContext.gigyaAccount.profile.firstName
                              )} ${firstUpperOnly(
                                data.gigyaContext.gigyaAccount.profile.lastName
                              )}`}
                            </span>
                          </div>
                        </div>

                        {options.map((value, index) => (
                          <>
                            <hr color="#E0E0E0" />
                            <li
                              onClick={value.onAction}
                              className={`a-login__container__float-box__options__option ${value.gtm}`}
                              key={index}
                            >
                              {/* <i
                              className={`a-login__container__float-box__options__option__icon ${value.icon} ${value.gtm}`}
                            /> */}
                              {value.title}
                            </li>
                          </>
                        ))}
                      </ul>
                      <div
                        className="a-login__container__float-box__background"
                        onClick={() => doShow(false)}
                      ></div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <i
                    className={`a-login__icon icon-user hide-all gtmRedDeAmorIniciarSesion`}
                    onClick={data.gigyaContext.login}
                  />
                  <span
                    className={`a-login__title__start hide-mobile ${
                      props.isMenuActive ? "a-login__title-open" : ""
                    } gtmRedDeAmorIniciarSesion`}
                    onClick={data.gigyaContext.login}
                  >
                    {props.title}
                  </span>
                  {props.isMenuActive ? (
                    <i
                      className="a-login__icon icon-user hide-desktop gtmRedDeAmorIniciarSesion"
                      onClick={data.gigyaContext.login}
                    ></i>
                  ) : null}
                </>
              )}
            </>

            <ModalPay
              open={open}
              onClose={toggleModal}
              login={data.gigyaContext.login}
              gigyaAccount={data.gigyaContext.gigyaAccount}
            />
          </div>
        );
      }}
    </GlobalContext.Consumer>
  );
};

export default Login;
